/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ============================================================================
// SHARED SHIPPING CALCULATION UTILITY
// ============================================================================
async function calculateShippingDates(shipdays) {
  // Fetch current server time from Shopify
  let serverTime;
  try {
    const response = await fetch(window.location.href, {
      method: 'HEAD',
      cache: 'no-store'
    });
    const dateHeader = response.headers.get('date');
    if (!dateHeader) {
      console.error('[SHIPPING CALC] No date header in response');
      return null;
    }
    serverTime = new Date(dateHeader);
    if (isNaN(serverTime.getTime())) {
      console.error('[SHIPPING CALC] Invalid date from server');
      return null;
    }
  } catch (e) {
    console.error('[SHIPPING CALC] Failed to get server time:', e);
    return null;
  }

  let futureDate = new Date(serverTime);
  let daysAdded = 0;

  while (daysAdded < shipdays) {
    futureDate.setDate(futureDate.getDate() + 1);  
    const day = futureDate.getDay();                
    if (day !== 0 && day !== 6) daysAdded++;      
  }

  return {
    shippingNotice: `${futureDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`
  };
}



// main atc

(() => {
  const dpContainer = document.querySelector('[data-damage-protection-container]');
  const dpCheckbox = dpContainer ? document.getElementById('damage-protection-double') : null;
  
  let dpVariantId = dpCheckbox?.getAttribute('data-dp-variant') || null;
  if (!dpVariantId && dpCheckbox?.checked) {
    console.warn('[DP] data-dp-variant missing! Check your HTML.');
  }

  const tuneContainer = document.querySelector('#component-lube-service');
  const getTuneId = () => {
    if (!tuneContainer) return null;
    const select = document.getElementById('lube-service-select');
    if (select && select.value && select.value !== 'none') return select.value;
    const radio = document.querySelector('input[name="setup_service"]:checked');
    return radio && radio.value !== 'none' ? radio.value : null;
  };

  const pvcContainer = document.querySelector('#content-pvc-coating');
  const getPvcId = () => {
    if (!pvcContainer) return null;
    const checkbox = document.getElementById('pvc-coating-checkbox');
    if (!checkbox || !checkbox.checked) return null;
    return checkbox.dataset.pid || null;
  };

  const form = dpContainer?.closest('form') || tuneContainer?.closest('form') || pvcContainer?.closest('form') || document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const variantInput = form.querySelector('[name="id"]');
  if (!variantInput) return;

  document.addEventListener('DOMContentLoaded', () => {
    const dpLabel = document.querySelector('label[for="damage-protection-double"]');
    if (dpCheckbox && dpLabel) {
      dpCheckbox.addEventListener('change', () => {
        dpLabel.classList.toggle('is-selected', dpCheckbox.checked);
      });
    }
  });

  const originalFetch = window.fetch;
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : input.url;
    if (!url.includes('/cart/add.js')) return originalFetch(input, init);

    let payload;
    try { 
      payload = init?.body ? JSON.parse(init.body) : null; 
    } catch (e) { 
      console.error('[SERVICES] JSON parse failed:', e);
      return originalFetch(input, init); 
    }
    if (!payload) return originalFetch(input, init);

    const currentVariantId = variantInput.value;
    const hasOurVariant = 
      String(payload.id) === currentVariantId ||
      (payload.items && payload.items.some(i => String(i.id) === currentVariantId));

    if (!hasOurVariant) return originalFetch(input, init);

    const items = payload.items || [{
      id: payload.id,
      quantity: payload.quantity || 1,
      properties: payload.properties || {}
    }];

    const mainItem = items.find(i => String(i.id) === currentVariantId);
    if (!mainItem) return originalFetch(input, init);

    const pairId = `svc_${Date.now().toString(36)}`;

    let modified = false;
    let productSku = ''; // fallback
    
    // Extract product handle from URL (assuming product page)
    let handle = null;
    const pathParts = window.location.pathname.split('/');
    const productsIndex = pathParts.indexOf('products');
    if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
      handle = pathParts[productsIndex + 1].split('?')[0];
    }

    let preOrderShipDate = null;
    let shipDaysOverride = null;   
    /*
    if (handle) {
      try {
        const productResp = await fetch(`/products/${handle}.js`);
        if (productResp.ok) {
          const productData = await productResp.json();

          // Existing pre-order
          const preOrderMf = productData?.metafields?.find(
            m => m.namespace === 'my_fields' && m.key === 'pre_order_ship_date'
          );
          preOrderShipDate = preOrderMf ? preOrderMf.value : null;

          // New ship days override (namespace = custom, key = ship_days_override)
          const overrideMf = productData?.metafields?.find(
            m => m.namespace === 'custom' && m.key === 'ship_days_override'
          );
          shipDaysOverride = overrideMf ? Number(overrideMf.value) : null;

          // Optional safety check
          if (shipDaysOverride !== null && isNaN(shipDaysOverride)) {
            console.warn('ship_days_override is not a number:', overrideMf.value);
            shipDaysOverride = null;
          }
        }
      } catch (e) {
        console.error('Error fetching product data', e);
      }
    }
    */
   
    let isBackorder = false;
    // Fetch variant info from Shopify
    try {
      const variantResp = await fetch(`/variants/${mainItem.id}.js`);
      if (variantResp.ok) {
        const variantData = await variantResp.json();

        productSku = variantData.sku || '';

        isBackorder =
          variantData.inventory_management &&
          variantData.inventory_quantity <= 0 &&
          variantData.inventory_policy === 'continue';

        if (preOrderShipDate) {
          const shipDate = new Date(preOrderShipDate);
          if (!isNaN(shipDate.getTime())) {
            const formatted = shipDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            mainItem.properties['Ship Date'] = (window.rtbs || '') + ' ' + `${formatted}`;
            
            mainItem.properties['_backorder'] = 1;
            modified = true;
          }
        } else {
          const shipdays = isBackorder ? 7 : 0;

          // Add product-level override if it exists
          if (shipDaysOverride !== null && shipDaysOverride > 0) {
            shipdays += shipDaysOverride;
          }

          if (shipdays > 0) {
            const dates = await calculateShippingDates(shipdays);

            mainItem.properties['_shipdays'] = shipdays;
            mainItem.properties['_backorder'] = isBackorder ? 1 : 0;
            if (isBackorder)
            {
              mainItem.properties['Ship Date'] = (window.rtbs || '') + ' ' + dates.shippingNotice;
              
            }
            else
            if (dates) {
              mainItem.properties['Ship Date'] = (window.rtbs || '') + ' ' + dates.shippingNotice;
            }

            modified = true;
          }
        }
      } else {
        console.error('Failed to fetch variant info', variantResp.status);
      }
    } catch (e) {
      console.error('Error fetching variant info', e);
    }


    mainItem.properties = mainItem.properties || {};
    mainItem.properties['_productid'] = pairId;

    const parentQuantity = mainItem.quantity;

    // ===  GET OVERRIDES FROM SELECTED OPTIONS (PVC & TUNE) ===
    const pvcCheckbox = document.getElementById('pvc-coating-checkbox');
    let pvcOverride = null;
    if (pvcCheckbox?.checked) {
      const overrideAttr = pvcCheckbox.getAttribute('data-ship-days-override');
      if (overrideAttr) {
        pvcOverride = Number(overrideAttr);
      }
    }

    // Only count tune if Pro Tune is actually enabled
    const proTuneChecked = document.getElementById('pro-tune-toggle')?.checked;

    const tuneEl = document.querySelector('input[name="setup_service"]:checked');
    const tuneLabel = tuneEl?.closest('label'); 

    const tuneOverride = proTuneChecked && tuneLabel
      ? Number(tuneLabel.dataset.shipDaysOverride || 0)
      : null;


    // ===  COLLECT ALL SERVICE OVERRIDES ===
    const serviceOverrides = [];
    if (pvcOverride !== null && !isNaN(pvcOverride)) serviceOverrides.push(pvcOverride);
    if (tuneOverride !== null && !isNaN(tuneOverride)) serviceOverrides.push(tuneOverride);

    // ===  APPLY MAX OVERRIDE TO MAIN PRODUCT & CORRECT NOTICE ===
    if (serviceOverrides.length > 0) {
      const maxServiceDays = Math.max(...serviceOverrides);
      const baseShipdays = mainItem.properties['_shipdays'] || 0;
      const finalMainShipdays = baseShipdays + maxServiceDays;

      mainItem.properties['_shipdays'] = finalMainShipdays;

      const dates = await calculateShippingDates(finalMainShipdays);
      if (dates) {

        if (preOrderShipDate || isBackorder)
        {
          mainItem.properties['Ship Date'] =  (window.rtbs || '') + ' ' + dates.shippingNotice;
        }
        else
        {
          mainItem.properties['Ship Date'] = (window.rtbs || '') + ' ' +  dates.shippingNotice;
        }
      }

      modified = true;
    }

    const tuneId = proTuneChecked ? getTuneId() : null;
    if (tuneId) {
      const tuneItem = {
        id: tuneId,
        quantity: parentQuantity,
        properties: {
          'SKU To Apply': productSku,
          '_Apply To': pairId
        }
      };
      if (tuneOverride !== null && !isNaN(tuneOverride)) {
        tuneItem.properties['_shipdays'] = tuneOverride;
      }
      items.unshift(tuneItem);
      modified = true;
    }

    // ===  DAMAGE PROTECTION WITH Apply To AND DEBUG ===
    if (dpCheckbox?.checked && dpVariantId) {
      items.unshift({
        id: dpVariantId,
        quantity: parentQuantity,
        properties: {
          'SKU To Apply': productSku,
          '_Apply To': pairId
        }
      });
      modified = true;
    } else if (dpCheckbox?.checked) {
      console.error('[DP] NOT ADDED: dpVariantId is missing or null');
    }

    const pvcId = getPvcId();
    if (pvcId) {
      const pvcItem = {
        id: pvcId,
        quantity: parentQuantity,
        properties: {
          'SKU To Apply': productSku,
          '_Apply To': pairId
        }
      };
      if (pvcOverride !== null && !isNaN(pvcOverride)) {
        pvcItem.properties['_shipdays'] = pvcOverride;
      }
      items.unshift(pvcItem);
      modified = true;
    }

    if (!modified) return originalFetch(input, init);
    const newInit = { ...init, body: JSON.stringify({ items }) };
    let resp;
    try {
      resp = await originalFetch(input, newInit);
    } catch (e) {
      console.error('[SERVICES] Fetch failed:', e);
      return resp;
    }

    if (!resp.ok) {
      console.error('[SERVICES] Add failed:', await resp.clone().json().catch(() => 'Unknown error'));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    return resp;
  };
})();


// update

(() => {
  const originalFetch = window.fetch;
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : input.url;
    if (!url.includes('/cart/change.js') && !url.includes('/cart/update.js')) {
      return originalFetch(input, init);
    }

    // === GET CURRENT CART ===
    let cart;
    try {
      const resp = await originalFetch('/cart.js');
      if (!resp.ok) throw new Error('Cart fetch failed');
      cart = await resp.json();
    } catch (e) {
      console.error('[CART-CLEANUP] Failed to get cart:', e);
      return originalFetch(input, init);
    }

    // === MAP: Apply To → [service keys] ===
    const serviceMap = new Map();
    cart.items.forEach(item => {
      const applyTo = item.properties?.['_Apply To'];
      if (applyTo) {
        if (!serviceMap.has(applyTo)) serviceMap.set(applyTo, []);
        serviceMap.get(applyTo).push(item.key);
      }
    });

    // === PARSE PAYLOAD ===
    let payload;
    try {
      payload = init?.body ? JSON.parse(init.body) : null;
    } catch (e) {
      console.error('[CART-CLEANUP] Payload parse failed:', e);
      return originalFetch(input, init);
    }
    if (!payload) return originalFetch(input, init);

    const changes = {};
    let isRemoveRequest = false;
    let targetLineKey = null;

    if (url.includes('/cart/change.js')) {
      if (payload.line !== undefined && payload.quantity !== undefined) {
        const lineIndex = payload.line - 1;
        if (cart.items[lineIndex]) {
          targetLineKey = cart.items[lineIndex].key;
          changes[targetLineKey] = payload.quantity;
          if (payload.quantity === 0) isRemoveRequest = true;
        }
      } else if (payload.id && payload.quantity !== undefined) {
        targetLineKey = payload.id;
        changes[targetLineKey] = payload.quantity;
        if (payload.quantity === 0) isRemoveRequest = true;
      }
    } else if (url.includes('/cart/update.js') && payload.updates) {
      Object.entries(payload.updates).forEach(([key, qty]) => {
        changes[key] = qty;
        if (qty === 0) isRemoveRequest = true;
      });
    }

    if (Object.keys(changes).length === 0) return originalFetch(input, init);

    // === BUILD FULL CLEANUP + RECALC MAIN PRODUCT ===
    const fullCleanup = { ...changes };
    let mainItem = null;
    let mainKey = null;

    for (const [lineKey, newQty] of Object.entries(changes)) {
      const item = cart.items.find(i => i.key === lineKey);
      if (!item) continue;

      // Track main product
      if (item.properties?.['_productid']) {
        mainItem = item;
        mainKey = lineKey;
      }

      const parentId = item.properties?.['_productid'];
      if (!parentId) continue;

      const services = serviceMap.get(parentId) || [];
      if (newQty === 0) {
        services.forEach(key => { fullCleanup[key] = 0; });
      } else if (newQty > 0) {
        services.forEach(key => {
          const svc = cart.items.find(i => i.key === key);
          if (svc && svc.quantity !== newQty) {
            fullCleanup[key] = newQty;
          }
        });
      }
    }

    // === RECALCULATE MAIN PRODUCT SHIPPING ===
    if (mainItem && mainKey) {
      // Collect all current service _shipdays
      const serviceOverrides = [];
      const parentId = mainItem.properties['_productid'];
      const services = serviceMap.get(parentId) || [];

      services.forEach(key => {
        const svc = cart.items.find(i => i.key === key);
        if (svc && svc.properties?.['_shipdays']) {
          const days = parseInt(svc.properties['_shipdays'], 10);
          if (!isNaN(days)) serviceOverrides.push(days);
        }
      });

      const maxServiceDays = serviceOverrides.length > 0 ? Math.max(...serviceOverrides) : 0;
      const baseShipdays = mainItem.properties['_shipdays'] || 0;
      const originalBackorder = mainItem.properties['_backorder'] == 1;

      // Only apply if services exist
      let finalShipdays = baseShipdays;
      let isBackorderForCalc = originalBackorder;

      if (maxServiceDays > 0) {
        finalShipdays = baseShipdays > 0 ? baseShipdays + maxServiceDays : maxServiceDays;
        isBackorderForCalc = false; // override disables range
      } else if (baseShipdays === 0 && originalBackorder) {
        finalShipdays = 7;
        isBackorderForCalc = true;
      }

      // Only update if changed
      const currentShipdays = mainItem.properties['_shipdays'];
      const currentNotice = mainItem.properties['Ship Date'];

      if (finalShipdays !== currentShipdays || (maxServiceDays === 0 && originalBackorder)) {
        mainItem.properties['_shipdays'] = finalShipdays;
/*
        const dates = await calculateShippingDates(isBackorderForCalc, finalShipdays);
        const newNotice = dates ? dates.shippingNotice : currentNotice;

        if (newNotice !== currentNotice) {
          mainItem.properties['Ship Date'] = newNotice;
          
        }
*/

        
        const dates = await calculateShippingDates(finalShipdays);
        

        let newNotice;
        if (isBackorderForCalc || maxServiceDays > 0) {
          // Match the add-to-cart behavior
          newNotice = (window.rtbs || '') + ' ' + (dates?.shippingNotice || '');
        } else {
          newNotice = (window.rtbs || '') + ' ' + (dates?.shippingNotice || '');
        }

        if (newNotice !== currentNotice) {
          mainItem.properties['Ship Date'] = newNotice.trim();
        }
        


        // Update main item in cleanup
        fullCleanup[mainKey] = mainItem.quantity;
      }
    }

    // === APPLY CLEANUP ===
    if (Object.keys(fullCleanup).length > 0) {
      let cleanupResp;
      try {
        cleanupResp = await originalFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: fullCleanup })
        });
      } catch (e) {
        console.error('[CART-CLEANUP] Cleanup fetch failed:', e);
        return originalFetch(input, init);
      }

      if (!cleanupResp.ok) {
        console.error('[CART-CLEANUP] Cleanup failed:', await cleanupResp.clone().json().catch(() => 'Unknown error'));
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    }

    if (isRemoveRequest && targetLineKey && fullCleanup[targetLineKey] === 0) {
      return new Response(JSON.stringify({}), { status: 200 });
    }

    return originalFetch(input, init);
  };
})();

/*
// FSB — Injects into .mini-cart__inner or .mini-cart__content--empty as first child
(() => {
  let original = null;
  let debounceTimer = null;
  const DEBOUNCE_DELAY = 100;

  const stripIds = (node) => {
    if (node.id) node.removeAttribute('id');
    node.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
  };

  const getTarget = () => {
    const inner = document.querySelector('.mini-cart__inner');
    if (inner) return inner;
    const empty = document.querySelector('.mini-cart__content--empty');
    if (empty) return empty;
    return null;
  };

  const injectFSB = () => {
    if (!original) {
      original = document.querySelector('#fsb_container');
      if (!original) return;
      original.style.display = 'none';
    }

    const target = getTarget();
    if (!target) return;

    target.querySelectorAll('.fsb-injected').forEach(el => el.remove());

    const clone = original.cloneNode(true);
    stripIds(clone);
    clone.classList.add('fsb-injected');
    clone.style.cssText = 'display: block !important; width: 100% !important; margin: 0 0 16px !important;';

    target.insertBefore(clone, target.firstChild);
  };

  // Wait for FSB
  const fsbWait = new MutationObserver(() => {
    if (document.querySelector('#fsb_container')) {
      original = document.querySelector('#fsb_container');
      original.style.display = 'none';
      fsbWait.disconnect();

      if (getTarget()) injectFSB();

      new MutationObserver(injectFSB).observe(original, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    }
  });
  fsbWait.observe(document.body, { childList: true, subtree: true });

  // Observe #mini-cart
  const miniCart = document.querySelector('#mini-cart');
  if (miniCart) {
    const cartObserver = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(injectFSB, DEBOUNCE_DELAY);
    });
    cartObserver.observe(miniCart, { childList: true, subtree: true });
  }

  // Events
  document.addEventListener('cart:refresh', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(injectFSB, DEBOUNCE_DELAY);
  });

  document.addEventListener('drawer:opened', () => {
    setTimeout(injectFSB, 100);
  });

  // Initial
  if (document.querySelector('#fsb_container') && getTarget()) {
    injectFSB();
  }
})();
*/




// product page shipdays
// ============================================================================
// INVENTORY MESSAGE TOGGLER - Shows/hides inventory spans based on services
// ============================================================================
(() => {
  // Only run on product pages
  if (typeof theme === 'undefined' || theme.pageType !== 'product') return;

  const pvcCheckbox = document.getElementById('pvc-coating-checkbox');
  const tuneCheckbox = document.getElementById('pro-tune-toggle');
  const tuneRadios = document.querySelectorAll('input[name="setup_service"]');

  const baseSpan = document.querySelector('[data-inventory-base]');
  const pvcSpan = document.querySelector('[data-inventory-with-pvc]');
  const tuneSpan = document.querySelector('[data-inventory-with-tune]');
  const bothSpan = document.querySelector('[data-inventory-with-both]');

  if (!baseSpan) return;

  const updateInventoryDisplay = () => {
    // Check PVC checkbox
    const hasPvc = pvcCheckbox && pvcCheckbox.checked;

    // Check Tune/Lube service selection - ONLY checkbox now
    let hasTune = false;
    if (tuneCheckbox) {
      hasTune = tuneCheckbox.checked;
    }

    // Hide all spans first
    baseSpan.style.display = 'none';
    if (pvcSpan) pvcSpan.style.display = 'none';
    if (tuneSpan) tuneSpan.style.display = 'none';
    if (bothSpan) bothSpan.style.display = 'none';

    // Show appropriate span
    if (hasPvc && hasTune && bothSpan) {
      bothSpan.style.display = '';
    } else if (hasPvc && pvcSpan) {
      pvcSpan.style.display = '';
    } else if (hasTune && tuneSpan) {
      tuneSpan.style.display = '';
    } else {
      baseSpan.style.display = '';
    }
  };

  // Attach listeners
  if (pvcCheckbox) {
    pvcCheckbox.addEventListener('change', updateInventoryDisplay);
  }

  if (tuneCheckbox) {
    tuneCheckbox.addEventListener('change', updateInventoryDisplay);
  }

  // Listen for variant changes
  document.addEventListener('variant:changed', () => {
    // Wait for DOM update, then recheck
    setTimeout(updateInventoryDisplay, 50);
  });

  // Initial check
  updateInventoryDisplay();
})();


/******
 * Shipping protection
 */
(function() {
  'use strict';

  const CONFIG = {
    protectionPercentage: 0.03,
    minimumProtection: 0.75,
    navidiumProductHandle: 'navidium-shipping-protection'
  };

  let cachedVariants = null;

  async function loadProtectionVariants() {
    if (cachedVariants) return cachedVariants;

    try {
      const res = await fetch('/products/' + CONFIG.navidiumProductHandle + '.js');
      if (!res.ok) throw new Error('Protection product not found');
      const product = await res.json();
      
      cachedVariants = product.variants.map(v => ({
        price: parseFloat((v.price / 100).toFixed(2)),
        variantId: v.id
      })).sort((a, b) => a.price - b.price);
      
      return cachedVariants;
    } catch (err) {
      console.error('Failed to load Navidium variants:', err);
      return [];
    }
  }

  async function getCartData() {
    try {
      const res = await fetch('/cart.js');
      return await res.json();
    } catch (e) {
      console.error('Cart fetch failed:', e);
      return null;
    }
  }

  function calculateCartTotal(cart) {
    if (!cart) return { totalBeforeProtection: 0, existingVariantId: null };

    let total = 0;
    let existingVariantId = null;
    cart.items.forEach(item => {
      if (item.handle === CONFIG.navidiumProductHandle) {
        existingVariantId = item.variant_id;
      } else {
        total += item.final_line_price;
      }
    });
    
    return {
      totalBeforeProtection: total / 100,
      existingVariantId
    };
  }

  function calculateProtectionAmount(subtotal) {
    return Math.max(subtotal * CONFIG.protectionPercentage, CONFIG.minimumProtection);
  }

  function findBestVariant(amount, variants) {
    if (variants.length === 0) return null;

    const rounded = Math.round(amount / 0.75) * 0.75;

    const exact = variants.find(v => v.price === rounded);
    if (exact) return exact;

    return variants.reduce((best, curr) => {
      const currDiff = Math.abs(curr.price - rounded);
      const bestDiff = Math.abs(best.price - rounded);
      return currDiff < bestDiff ? curr : best;
    });
  }

  async function removeProtection(variantId) {
    if (!variantId) return;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      });
    } catch (e) {
      console.warn('Remove protection failed:', e);
    }
  }

  async function addProtection(variantId) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    } catch (e) {
      console.error('Add protection failed:', e);
      throw e;
    }
  }

  // NEW: Remove any existing protection on page load
  async function clearExistingProtectionOnInit() {
    try {
      const cart = await getCartData();
      if (!cart) return;

      const protectionItems = cart.items.filter(item => 
        item.handle === CONFIG.navidiumProductHandle
      );

      if (protectionItems.length > 0) {
        console.log('Removing existing shipping protection on init');
        for (const item of protectionItems) {
          await removeProtection(item.variant_id);
        }
      }
    } catch (err) {
      console.error('Failed to clear protection on init:', err);
    }
  }

  async function handleProtectedCheckout(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const button = event.currentTarget;
    const originalText = button.innerHTML;
    //button.innerHTML = 'Adding protection...';
    button.disabled = true;

    try {
      const [cart, variants] = await Promise.all([
        getCartData(),
        loadProtectionVariants()
      ]);

      if (!cart) throw new Error('Cart unavailable');
      if (variants.length === 0) throw new Error('No protection variants available');

      const info = calculateCartTotal(cart);
      const amount = calculateProtectionAmount(info.totalBeforeProtection);
      const variant = findBestVariant(amount, variants);

      if (!variant) throw new Error('No suitable variant found');

      console.log(`Protection: $${amount.toFixed(2)} → using variant $${variant.price} (ID: ${variant.variantId})`);

      if (info.existingVariantId !== variant.variantId) {
        if (info.existingVariantId) {
          await removeProtection(info.existingVariantId);
        }
        await addProtection(variant.variantId);
      }

      localStorage.setItem('nvd_opted_in', 'true');

      window.location.href = '/checkout';

    } catch (err) {
      console.error('Protected checkout failed:', err);
      alert('Could not add protection. Proceeding to normal checkout?');
      window.location.href = '/checkout';
    }
  }

  function attachHandlers() {
    const selector = 'button.checkout-with-protection[type="submit"], input.checkout-with-protection[type="submit"]';
    
    document.querySelectorAll(selector).forEach(btn => {
      if (btn.dataset.protectionHandled) return;
      btn.dataset.protectionHandled = 'true';

      btn.addEventListener('click', handleProtectedCheckout, true);

      const form = btn.closest('form');
      if (form) {
        form.addEventListener('submit', e => {
          if (e.submitter === btn) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }, true);
      }
    });
  }

  async function init() {
    // Clear any leftover protection first
    await clearExistingProtectionOnInit();

    attachHandlers();

    new MutationObserver(() => {
      if (document.querySelector('.checkout-with-protection:not([data-protection-handled])')) {
        attachHandlers();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();